import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../../services/loader.service';
import { Routes, RouterModule , Router,ActivatedRoute} from '@angular/router';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {FinanceService} from '../finance.service';
declare var $:any;

@Component({
  selector: 'app-list-boqs',
  templateUrl: './list-boqs.component.html',
  styleUrls: ['./list-boqs.component.css'],
  providers:[FinanceService, LoaderService]
})
export class ListBoqsComponent implements OnInit {

	role;
	successalert = false;
	successMessage : string;
	errorMessage : string;
	erroralert = false;
	proposaldocList;
  paymentList;
	project_id;
  projectName;
  proposalId;
  proposalName;
  approvalForm: FormGroup;

  constructor(
  	private loaderService : LoaderService,
  	private financeService:FinanceService,
    private route:ActivatedRoute,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
  	this.role =localStorage.getItem('user');
		this.route.params.subscribe(params => {
			this.project_id = params['id'];
			this.proposalId = params['proposal_id'];
		});
		this.route.queryParams.subscribe(params => {
			this.projectName = params['project_name'];
			this.proposalName = params['proposal_name'];
		});
    this.approvalForm = this.fb.group({
      'id': ['', Validators.required],
      'approve' : ['', Validators.required],
      'remarks': ['']
    });
		this.getBoqList();
  }

  getBoqList(){
  	this.loaderService.display(true);
  	this.financeService.getBoqList(this.project_id).subscribe(
  		res=>{
  			console.log(res);
  			this.proposaldocList=res.quotations;
   
  			this.loaderService.display(false);
  		},
  		err=>{
  			console.log(err);
  			this.loaderService.display(false);
  		}
  	);
  }

  paymentId;
  setPaymentDocId(value){

    this.paymentId = value;
    console.log(this.paymentId);
  }
  paymentApprove(value){
    this.approvePay(this.paymentId,value);
  }
  approvePay(payId,status){
    this.approvalForm.patchValue({approve: status});
    if (status == true) {
      var str = 'Approved';
    }
    else{
      var str = 'Rejected';
    }
    console.log(this.approvalForm.value);
    this.financeService.approvePayments(this.project_id,payId,this.approvalForm.value).subscribe(
      res=>{
        console.log(res);
        $("#approvePayment").modal("hide");
          // if(this.state == 'initial_design'){

          // }
          // else if(this.state == 'final_design'){
          //   this.getPercentBoqs(this.state);
          // }
        this.getPercentBoqs(this.state);
        this.getBoqList();
        this.getPaymentDetails();
        this.successalert = true;
        this.successMessage = 'Payment ' +str+ ' successfully!';
        this.loaderService.display(false);
         setTimeout(function() {
            this.successalert = false;
        }.bind(this), 10000);
      },
      err=>{
       console.log(err);
      }
      );
  }

  payment_details_Arr;
  getPaymentDetails(){
  	this.loaderService.display(true);
  	this.financeService.getPaymentDetails(this.project_id).subscribe(
  		res=>{
  			console.log(res);
  			this.payment_details_Arr=res.payments;
  			console.log(this.payment_details_Arr);
  			this.loaderService.display(false);
  		},
  		err=>{
  			console.log(err);
  			this.loaderService.display(false);
  		}
  	);
  }
  // for payment boq list
  payment_details;
  getPaymentQuotation(paymentId){
    console.log(paymentId);
    this.loaderService.display(true);
    this.financeService.getPaymentQuotation(this.project_id,paymentId).subscribe(
      res=>{
        console.log(res);
        this.payment_details=res['payment']['quotation_payments'];
        console.log(this.payment_details);
        this.loaderService.display(false);
      },
      err=>{
        console.log(err);
        this.loaderService.display(false);
      }
    );

  }

  verifyPayment(paymentId){
  	this.loaderService.display(true);
  	this.financeService.verifyPayment(paymentId).subscribe(
  		res=>{
  			console.log(res);
  			this.payment_details_Arr=res.payments;
  			this.successMessageShow('Verified successfully');
  			this.loaderService.display(false);
  		},
  		err=>{
  			console.log(err);
  			this.errorMessageShow(JSON.parse(err['_body']).message);
  			this.loaderService.display(false);
  		}
  	);
  }
  errorMessageShow(msg){
    this.erroralert = true;
    this.errorMessage = msg;
    setTimeout(function() {
      this.erroralert = false;
    }.bind(this), 2000);
  }
  successMessageShow(msg){
    this.successalert = true;
    this.successMessage = msg;
    setTimeout(function() {
      this.successalert = false;
    }.bind(this), 2000);
  }
  state = 'boq';
  selectSet(set){
    this.state = set;
    if(this.state  == 'payment'){
      this.getPaymentDetails();
    }
    else if(this.state == 'initial_design'){
      this.getPercentBoqs(this.state);
    }
    else if(this.state == 'final_design'){
      this.getPercentBoqs(this.state);
    }
    else{
      this.getBoqList();
    }


  }

  percentDocs:any = [];
  getPercentBoqs(state){
    this.loaderService.display(true);
    this.financeService.getPercentBoqs(this.project_id,state).subscribe(
      res=>{
        console.log(res);
        this.percentDocs=res.quotations;
        // this.successMessageShow('Verified successfully');
        this.loaderService.display(false);
      },
      err=>{
        console.log(err);
        this.errorMessageShow(JSON.parse(err['_body']).message);
        this.loaderService.display(false);
      }
    );
  }

  openpopup(event,id){
    var thisobj=this;
    $(event.target).popover({
      trigger:'hover'
    });
   
    //$(this).popover();
    $(function () {
      $('.pop').popover({
        trigger:'hover'
      })
    }) 
  }

  calculatePendingAmt(state, total_amt, paid_amt){
    var total_amount = parseFloat(total_amt);
    var paid_amount = parseFloat(paid_amt);
    if(isNaN(total_amount)){
      total_amount = 0;
    }

    if(isNaN(paid_amount)){
      paid_amount = 0;
    }
    if(state == 'initial_design'){
      var final_amount = (10*total_amount)/100 - paid_amount
    }
    else if(state == 'final_design'){
      var final_amount = (50*total_amount)/100 - paid_amount
    }

    if(final_amount < 0){
      final_amount = 0
    }
    return final_amount
  }

  
  ngOnDestroy(){
    $(function () {
      $('.pop').remove();
    })
  }
  ngAfterViewInit(){

    $(function () {
         $('.pop').popover({
           trigger:'hover'
         })
    })
  }

  history:any= [];
  getPaymentHistory(boq_id){
    this.loaderService.display(true);
    this.financeService.getPaymentHistory(this.project_id,boq_id).subscribe(
      res=>{
        console.log(res);
        this.history=res.payments;
        // this.successMessageShow('Verified successfully');
        this.loaderService.display(false);
      },
      err=>{
        console.log(err);
        this.errorMessageShow(JSON.parse(err['_body']).message);
        this.loaderService.display(false);
      }
    );
  }


}



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/finance/list-boqs/list-boqs.component.ts